import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ScrollTopService } from '../../../core/services/scroll-top.service';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { LocalStorageKey } from '../../../core/constants/user/local-storage-key';
import { RedirectWebsite } from '../../../core/constants/user/redirect-website';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  providers: [LocalStorageService]
})
export class IndexComponent implements OnInit {

  public userRole: string;
  public websiteUrl = RedirectWebsite.Url;

  constructor(private title: Title, private localStorageService:LocalStorageService) {
    this.title.setTitle("Dillo Docs | SMS");

    var role:string = this.localStorageService.getWithExpiry(LocalStorageKey.UserRole);
    this.userRole = role != null ? role.toLowerCase() : "customer";
  }

  ngOnInit() {
    //this.scrollTopService.setScrollTop();
  }

}
